import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="notfound">
      <h1>Sorry :/</h1>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" >
        Go Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
